import { provideEnvironmentNgxMask } from 'ngx-mask';

import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, TitleStrategy } from '@angular/router';

import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { TemplatePageTitleStrategyService } from './core/services/template-page-title-strategy.service';
import { retryInterceptor } from './core/interceptors/retry.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    { provide: TitleStrategy, useClass: TemplatePageTitleStrategyService },
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([authInterceptor, retryInterceptor])),
    provideEnvironmentNgxMask(),
  ],
};
